export type ContactCentreSettingsTab = "user" | "settings";

export const CONTACT_CENTRE_SHIFT_HOURS = [4, 6, 8, 10, 12] as const;
export type ContactCentreShiftHours = (typeof CONTACT_CENTRE_SHIFT_HOURS)[number];

export type ContactCentreWorkingHours = {
  start: string;
  end: string;
  shiftHours: ContactCentreShiftHours | "";
};

export const EMPTY_CONTACT_CENTRE_WORKING_HOURS: ContactCentreWorkingHours = {
  start: "",
  end: "",
  shiftHours: "",
};

export function contactCentreTimeOptions(): string[] {
  const times: string[] = [];
  for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
    const hour = Math.floor(minutes / 60)
      .toString()
      .padStart(2, "0");
    const minute = (minutes % 60).toString().padStart(2, "0");
    times.push(`${hour}:${minute}`);
  }
  return times;
}

export function readContactCentreAccount(input: { userId?: string | null; email?: unknown }): {
  userId: string | null;
  email: string | null;
} {
  const userId =
    typeof input.userId === "string" && input.userId.trim() ? input.userId.trim() : null;
  const email = typeof input.email === "string" && input.email.trim() ? input.email.trim() : null;
  return { userId, email };
}
